import { createStructuredSelector } from 'reselect'

import {
   VALIDATION_DOCUMENT_REVIEW_LIST,
   VALIDATION_DOCUMENT_REVIEW_LIST_SUCCESS, 
   VALIDATION_DOCUMENT_REVIEW_LIST_ERROR,
   VALIDATION_DOCUMENT_REVIEW_PAGE_SET,
   VALIDATION_DOCUMENT_REVIEW_SEARCH_SET,
   VALIDATION_DOCUMENT_REVIEW_SEARCH_CHANGE,
   VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT,
   VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
   VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR, 
   VALIDATION_DOCUMENT_REVIEW_ADD_SET,
   VALIDATION_DOCUMENT_REVIEW_ADD_MODAL_SET,
   VALIDATION_DOCUMENT_REVIEW_ADD,
   VALIDATION_DOCUMENT_REVIEW_ADD_SUCCESS,
   VALIDATION_DOCUMENT_REVIEW_ADD_ERROR,
   VALIDATION_DOCUMENT_REVIEW_ADD_CHANGE,
   VALIDATION_DOCUMENT_REVIEW_DETAIL,
   VALIDATION_DOCUMENT_REVIEW_DETAIL_SUCCESS,
   VALIDATION_DOCUMENT_REVIEW_DETAIL_ERROR,
   VALIDATION_DOCUMENT_REVIEW_VIEW_MODAL_SET,
   VALIDATION_DOCUMENT_REVIEW_EDIT_CHANGE,
   VALIDATION_DOCUMENT_REVIEW_EDIT_MODAL_SET,
   VALIDATION_DOCUMENT_REVIEW_UPDATE,
   VALIDATION_DOCUMENT_REVIEW_UPDATE_SUCCESS,
   VALIDATION_DOCUMENT_REVIEW_UPDATE_ERROR,
   VALIDATION_DOCUMENT_REVIEW_VIEW_TAB_SET,
   VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET,
   VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_SUCCESS,
   VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_ERROR,
   VALIDATION_DOCUMENT_REVIEW_UPLOAD_RESET
} from '../actions';

export const VDR_NAME = 'validation_document_review';
const NAME = VDR_NAME;

export const ValidationDocumentReviewList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const ValidationDocumentReviewListSuccess = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_LIST_SUCCESS,
  payload: data
});

export const ValidationDocumentReviewListError = (error) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_LIST_ERROR,
  payload: error
});

export const ValidationDocumentReviewPageSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_PAGE_SET,
  payload: data
});

export const ValidationDocumentReviewSearchSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_SEARCH_SET,
  payload: data
});

export const ValidationDocumentReviewSearchChangeSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_SEARCH_CHANGE,
  payload: data
});

export const ValidationDocumentReviewSearchDeliveryOrderLineLot = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT,
  payload: data
});

export const ValidationDocumentReviewSearchDeliveryOrderLineLotSuccess = (message) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  payload: message
});

export const ValidationDocumentReviewSearchDeliveryOrderLineLotError = (error) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  payload: error
}); 

export const ValidationDocumentReviewAddChangeSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_ADD_CHANGE,
  payload: data
});

export const ValidationDocumentReviewAddSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_ADD_SET,
  payload: data
});

export const ValidationDocumentReviewAddModalSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_ADD_MODAL_SET,
  payload: data
});

export const ValidationDocumentReviewAdd = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_ADD,
  payload: data
});

export const ValidationDocumentReviewAddSuccess = (message) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_ADD_SUCCESS,
  payload: message
});

export const ValidationDocumentReviewAddError = (error) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_ADD_ERROR,
  payload: error
});

export const ValidationDocumentReviewDetail = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_DETAIL,
  payload: data
});

export const ValidationDocumentReviewDetailSuccess = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_DETAIL_SUCCESS,
  payload: data
});

export const ValidationDocumentReviewDetailError = (error) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_DETAIL_ERROR,
  payload: error
});

export const ValidationDocumentReviewViewModalSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_VIEW_MODAL_SET,
  payload: data
});

export const ValidationDocumentReviewEditModalSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_EDIT_MODAL_SET,
  payload: data
});

export const ValidationDocumentReviewEditChangeSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_EDIT_CHANGE,
  payload: data
});

export const ValidationDocumentReviewUpdate = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_UPDATE,
  payload: data
});

export const ValidationDocumentReviewUpdateSuccess = (message) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_UPDATE_SUCCESS,
  payload: message.message
});

export const ValidationDocumentReviewUpdateError = (error) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_UPDATE_ERROR,
  payload: error
});

export const ValidationDocumentReviewViewTabSet = (data) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_VIEW_TAB_SET,
  payload: data
});

export const ValidationDocumentReviewUploadSet = (file) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET,
  payload: { file },
});

export const ValidationDocumentReviewUploadSetSuccess = (items) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const ValidationDocumentReviewUploadSetError = (error) => ({
  type:  VALIDATION_DOCUMENT_REVIEW_UPLOAD_SET_ERROR,
  payload: error,
});

export const ValidationDocumentReviewUploadReset= () => ({
  type:  VALIDATION_DOCUMENT_REVIEW_UPLOAD_RESET
});

const validation_document_review = (state) => state[NAME];

export const ValidationDocumentReviewSelector = createStructuredSelector({
  validation_document_review
})
 